export const localeMap: { [key: string]: string } = {
    'en-US': 'en',
    'en-GB': 'en-gb',
    'fr-FR': 'fr',
    // Add other mappings as needed
};
